var $95082a5645b08160$exports = {};
$95082a5645b08160$exports = {
    "alert": `\u{12E}sp\u{117}jimas`,
    "dismiss": `Atmesti`
};


export {$95082a5645b08160$exports as default};
//# sourceMappingURL=lt-LT.mjs.map
